<script setup>
import CFIcon from '@/ui/Icon/CFIcon.vue';

defineProps({
    condition: {
        type: Boolean,
        default: false,
    },
});
</script>

<template>
    <div class="absolute inset-y-0 right-0 flex w-4 cursor-pointer items-center">
        <CFIcon
            :name="condition ? 'view-off' : 'view'"
            :size="16"
            class="shrink-0"
        />
    </div>
</template>
